<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import NavBar from "@/component/common/NavBar.vue";
import StageComponent from "@/component/project/StageComponent.vue";

@Component({
  components: {StageComponent, NavBar}
})
export default class StageView extends Vue {

}
</script>

<template>
  <NavBar/>
  <div class="view-container">
    <StageComponent/>
  </div>
</template>

<style scoped>
.view-container {
  margin-left: 80px;
  height: 100vh;
  background-color: var(--background-color);
  overflow-y: auto;
}
</style>